import { ColorArea } from './ColorArea';
import { ColorSlider, SliderTrack } from './ColorSlider';
import { ColorThumb } from './ColorThumb';

export type { ColorPickerProps } from 'react-aria-components';
export { ColorPicker } from 'react-aria-components';

/**
 * A set of controls for adjusting the color of a color picker.
 */
export function ColorPickerControls() {
    return (
        <>
            <ColorArea
                colorSpace="hsb"
                xChannel="saturation"
                yChannel="brightness"
                className="aspect-[3/2] w-full"
            >
                <ColorThumb />
            </ColorArea>
            <ColorSlider colorSpace="hsb" channel="hue">
                <SliderTrack>
                    <ColorThumb />
                </SliderTrack>
            </ColorSlider>
        </>
    );
}
